<template>
    <div class="cr:flex-1 cr:px-4 cr:relative cr:flex cr:flex-col cr:justify-center cr:items-center cr:text-gray-900 cr:font-normal">
        <CompanyRegistration/>
        <ErrorsModal/>
    </div>
</template>

<script setup lang="ts">

import CompanyRegistration from "@/views/CompanyRegistration.vue";
import {useRegistrationStore} from "@/stores/registration.ts";
import {onMounted} from "vue";
import ErrorsModal from "@/components/ErrorsModal.vue";

const props = defineProps({
    industries: {
        type: Array<string>,
        default: ['solar']
    },
    snitcherCode: {
        type: [String, null],
        default: null
    },
    origin: {
        type: [String, null],
        default: null
    }
});

onMounted(() => useRegistrationStore().init(props.industries, props.snitcherCode, props.origin));

</script>
